import Call from "~/assets/icons/Call";
import Contacts from "~/assets/icons/Contact";
import Visit from "~/assets/icons/Visit";

export default function SetupSectionAskAQuestion({ product }) {
    return (

        <>
            <div className="ico"></div>
            <div className="contactMeButtons">
                <h3>Negotiate?</h3>

                <a href={`/visit-me?${product.handle}&${product.title}`}>
                    <div className="ico-button">
                        <Visit />
                    </div>
                    <div className="text-button">
                        <span className="contactMeButtons__button">
                            Ask the Rep/Agent to visit messsssss
                        </span>
                    </div>
                </a>

                <a href={`/call-me?${product.handle}&${product.title}`}>
                    <div className="ico-button">
                        <Call />
                    </div>
                    <div className="text-button">
                        <span className="contactMeButtons__button">
                            Ask the Supplier to call me
                        </span>
                    </div>
                </a>

                <a href={JSON.parse(product.customField?.value || '')?.contacturl}>
                    <div className="ico-button">
                        <Contacts />
                    </div>
                    <div className="text-button">
                        <span className="contactMeButtons__button">
                            I will call - show me the contacts
                        </span>
                    </div>
                </a>

            </div>
        </>)
}